import moment from "moment/moment";

export default function (
  orderListData,
  commissionField,
  orderValueField,
  minCol = 12
) {
  const toNumber = (value) => +parseFloat(value || 0).toFixed(2);
  const orderList = orderListData || [];
  const labels = [];
  const datasets = [
    {
      label: "Commission",
      fill: true,
      backgroundColor: "#747bf3",
      borderRadius: 7,
      // yAxisID: "y",
      data: [],
    },
    {
      label: "Order Value",
      fill: true,
      backgroundColor: "#8e75db",
      borderRadius: 7,
      // yAxisID: "y1",
      data: [],
    },
  ];
  let lastKnownTime = moment().format("D MMM");
  if (orderList && orderList.length > 0) {
    orderList.forEach((x) => {
      labels.push(x.date);
      lastKnownTime = x.date;
      datasets[0].data.push(Math.abs(toNumber(x[commissionField])));
    });
    orderList.forEach((y) => {
      datasets[1].data.push(toNumber(y[orderValueField]));
    });
    if (datasets[0].data.length < minCol) {
      lastKnownTime = moment(`${labels[labels.length - 1]}`, "D MMM");
      Array(minCol - datasets[0].data.length)
        .fill(0)
        .forEach(() => {
          labels.unshift(lastKnownTime.add(-1, "days").format("D MMM"));
          datasets[0].data.unshift(0.0);
        });
    }
    if (datasets[1].data.length < minCol) {
      lastKnownTime = moment(`${labels[labels.length - 1]}`, "D MMM");
      Array(minCol - datasets[1].data.length)
        .fill(0)
        .forEach(() => {
          datasets[1].data.unshift(0.0);
        });
    }
  }
  return {
    labels,
    datasets,
  };
}
